import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Table, Button } from 'react-bootstrap';
import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import { BsGripVertical } from 'react-icons/bs';

function DraggableProjectsList({ projects, onReorder, onEdit, onDelete }) {
  const handleDragEnd = (result) => {
    if (!result.destination) {
      return; // Dropped outside the list
    }

    const items = Array.from(projects);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update display_order for all items
    const updatedOrders = items.map((item, index) => ({
      id: item.id,
      display_order: index
    }));

    onReorder(updatedOrders);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="projects">
        {(provided, snapshot) => (
          <Table 
            className="admin-table" 
            responsive
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
              backgroundColor: snapshot.isDraggingOver ? '#f8f9ff' : 'white'
            }}
          >
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Image</th>
                <th>Title</th>
                <th>Description</th>
                <th>GitHub</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project, index) => (
                <Draggable key={project.id} draggableId={`project-${project.id}`} index={index}>
                  {(provided, snapshot) => (
                    <tr
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={{
                        ...provided.draggableProps.style,
                        backgroundColor: snapshot.isDragging ? '#e3f2fd' : 'white',
                        boxShadow: snapshot.isDragging ? '0 5px 15px rgba(0,0,0,0.2)' : 'none'
                      }}
                    >
                      <td {...provided.dragHandleProps} style={{ cursor: 'grab', textAlign: 'center' }}>
                        <BsGripVertical size={20} color="#667eea" />
                      </td>
                      <td>
                        <img 
                          src={project.img_path} 
                          alt={project.title}
                          style={{ width: '100px', height: '70px', objectFit: 'cover', borderRadius: '8px' }}
                        />
                      </td>
                      <td><strong>{project.title}</strong></td>
                      <td>
                        <div 
                          dangerouslySetInnerHTML={{ 
                            __html: project.description.length > 100 
                              ? project.description.substring(0, 100).replace(/<[^>]*>/g, '') + '...' 
                              : project.description.replace(/<[^>]*>/g, '').substring(0, 100) + (project.description.length > 100 ? '...' : '')
                          }}
                        />
                      </td>
                      <td>
                        {project.gh_link ? (
                          <a href={project.gh_link} target="_blank" rel="noopener noreferrer" style={{ color: '#667eea', textDecoration: 'none' }}>
                            🔗 View
                          </a>
                        ) : <span style={{ color: '#999' }}>-</span>}
                      </td>
                      <td>
                        <Button 
                          className="btn-outline-primary-admin me-2" 
                          size="sm"
                          onClick={() => onEdit(project)}
                        >
                          <AiOutlineEdit style={{ marginRight: '0.25rem' }} />
                          Edit
                        </Button>
                        <Button 
                          className="btn-danger-admin" 
                          size="sm"
                          onClick={() => onDelete(project.id)}
                        >
                          <AiOutlineDelete style={{ marginRight: '0.25rem' }} />
                          Delete
                        </Button>
                      </td>
                    </tr>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </tbody>
          </Table>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default DraggableProjectsList;

